module.exports = __webpack_public_path__ + "static/media/post.0313f106.svg";